import React from 'react';
import { withErrorBoundary } from '@buzzfeed/react-components';
import { captureException } from '@sentry/nextjs';
import AdUnit from '../Ads/AdUnit';

function InlinePromoUnit(props) {
  return <AdUnit {...props} />;
}

export default withErrorBoundary(InlinePromoUnit, {
  onError: captureException,
});
